__turbopack_context__.v({
  "body": "Header-module-scss-module__cq1pzG__body",
  "header": "Header-module-scss-module__cq1pzG__header",
  "headerTitle": "Header-module-scss-module__cq1pzG__headerTitle",
  "subTitle": "Header-module-scss-module__cq1pzG__subTitle",
});
